import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import WildcraftLogo from './WildcraftLogo';

export default function PinLogin() {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleKey = (key) => {
    if (key === 'CLR') { setPin(''); setError(''); return; }
    if (key === 'DEL') { setPin(p => p.slice(0, -1)); return; }
    if (pin.length < 6) { setPin(p => p + key); setError(''); }
  };

  const handleSubmit = async () => {
    if (pin.length < 4) { setError('Enter at least 4 digits'); return; }
    setLoading(true);
    try { await login(pin); }
    catch (e) { setError(e.response?.data?.detail || 'Invalid PIN'); setPin(''); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-[#0D1F0D]" data-testid="pin-login-screen">
      <div className="w-full max-w-[320px] animate-fade-in">
        {/* Logo & Brand */}
        <div className="text-center mb-8">
          <WildcraftLogo size={64} className="mx-auto mb-4 animate-logo-breathe" />
          <h1 className="font-brand text-3xl sm:text-4xl font-bold text-white tracking-tight leading-none">
            Wildcraft
          </h1>
          <h2 className="font-brand text-xl sm:text-2xl text-[#7D8B69] italic -mt-0.5">Gatherings</h2>
          <p className="font-mono text-[10px] text-[#4A7C3F] uppercase tracking-[0.25em] mt-4">Enter PIN</p>
        </div>

        {/* PIN dots */}
        <div className="flex justify-center gap-3 mb-5" data-testid="pin-dots">
          {[0,1,2,3,4,5].map(i => (
            <div key={`pin-dot-${i}`} className={`w-4 h-4 border-2 transition-all duration-150 ${
              i < pin.length ? 'bg-[#4A7C3F] border-[#4A7C3F] scale-110' : 'border-[#4A7C3F]/40'
            } ${i >= 4 && pin.length <= 4 ? 'opacity-30' : ''}`} />
          ))}
        </div>

        {error && <p className="font-mono text-sm text-[#FF6B6B] text-center mb-4 animate-fade-in" data-testid="pin-error">{error}</p>}

        {/* Keypad */}
        <div className="grid grid-cols-3 border-2 border-[#4A7C3F]/40 bg-[#142814]">
          {['1','2','3','4','5','6','7','8','9','CLR','0','DEL'].map(key => (
            <button key={key} data-testid={`pin-pad-button-${key.toLowerCase()}`}
              onClick={() => handleKey(key)}
              className="h-[64px] font-mono text-xl font-bold border border-[#4A7C3F]/15 text-white bg-[#142814] hover:bg-[#4A7C3F] active:bg-[#4A7C3F] transition-colors duration-100 select-none">
              {key}
            </button>
          ))}
        </div>

        <button data-testid="pin-submit-btn" onClick={handleSubmit} disabled={loading || pin.length < 4}
          className="w-full h-14 mt-3 bg-[#4A7C3F] text-white font-mono text-base font-bold uppercase tracking-widest border-2 border-[#4A7C3F] hover:bg-[#7D8B69] transition-colors disabled:opacity-30 disabled:cursor-not-allowed">
          {loading ? 'CHECKING...' : 'ENTER'}
        </button>
      </div>
    </div>
  );
}

